import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import { LanguageContext } from '../i18n/LanguageContext';

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  static contextType = LanguageContext;
  declare context: React.ContextType<typeof LanguageContext>;
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false });
    window.location.href = import.meta.env.BASE_URL;
  };

  render() {
    if (this.state.hasError) {
      const t = this.context?.t;
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', p: 2 }}>
          <Card sx={{ maxWidth: 400, textAlign: 'center', borderRadius: 4 }}>
            <CardContent sx={{ p: 4 }}>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                {t?.somethingWentWrong ?? 'Something went wrong'}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {t?.unexpectedError ?? 'An unexpected error occurred. Please try again.'}
              </Typography>
              <Button variant="contained" onClick={this.handleReset}>
                {t?.goToStart ?? 'Go to start'}
              </Button>
            </CardContent>
          </Card>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
